import { type ReactNode, useState, useEffect } from 'react';
import { type TParamContext, ParamContext } from '@shared/configs';
import { useFetchParameters } from '@shared/configs/params/use-param-context';
import { useLocalStorage } from '@shared/lib/hooks';
import { LoadingPage } from '@pages/loading-page';

//ParamProvider, ONLY CHECKS TO SEE IF LOCAL STORAGE CONTAINS OUR PARAMS
export const ParamProvider = ({ children }: { children: ReactNode }) => {
  const [param, setParam] = useState<TParamContext | null>(null);
  const [wroteToStorage, setWroteToStorage] = useState(false);
  const { getItem, setItem } = useLocalStorage();
  const {
    data: paramData,
    refetch,
    isLoading,
    isSuccess,
  } = useFetchParameters();
  //Check to see if Params exist within localStorage
  useEffect(() => {
    const paramsFromStorage = getItem('signup_flow');
    if (!paramsFromStorage) {
      refetch();
    }
    if (!paramsFromStorage && paramData && Object.keys(paramData).length) {
      //If it isn't in storage AND paramData is populated
      setItem('signup_flow', JSON.stringify(paramData));
      setWroteToStorage(true);
    }
    if (
      paramsFromStorage &&
      Object.keys(paramsFromStorage) &&
      JSON.parse(paramsFromStorage) !== undefined
    ) {
      //If it was in storage
      setParam(JSON.parse(paramsFromStorage));
    }
  }, [isSuccess, isLoading, wroteToStorage]);

  if (!param) {
    return <LoadingPage />;
  }

  return (
    <>
      <ParamContext.Provider value={param}>{children}</ParamContext.Provider>
    </>
  );
};
